import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
/**
 * Expose the `userVerified` notification toggle in the user's preferences page.
 */
export default function addNotificationPreference() {
  extend('flarum/forum/components/NotificationGrid', 'notificationTypes', function (items) {
    items.add('userVerified', {
      name: 'userVerified',
      icon: 'fas fa-certificate',
      label: app.translator.trans('ramon-verified.forum.notifications.user_verified_preference')
    });
  });
}